import { track } from './sendData'

export default class Click {
    add(entry) {
        // const tp = entry.el.attributes['track-params'].value
        // console.log(entry.el.attributes['track-params']);
        
        entry.el.addEventListener('click', function () {
            // 元素可能没有 track-params 属性，做空值守卫，避免抛错
            const tpAttr = this.attributes['track-params']

            if (!tpAttr) {
                return
            }

            track(tpAttr.value)
        })
    }
}